import { CopyIcon } from "@chakra-ui/icons";
import { Button, Icon, Tooltip, useClipboard } from "@chakra-ui/react";
import { useEffect } from "react";

export const CopyToClipboardIcon = ({
  text,
  transform: transform = "normal",
}: {
  text: string;
  transform?: "uppercase" | "lowercase" | "normal";
}) => {
  const { onCopy, setValue, hasCopied } = useClipboard("");

  useEffect(() => {
    let _text = text;
    switch (transform) {
      case "uppercase":
        _text = _text.toUpperCase();
        break;
      case "lowercase":
        _text = _text.toLowerCase();
        break;
    }
    setValue(_text);
  }, []);

  return (
    <Tooltip isOpen={hasCopied} label="Copied!">
      <Icon
        /* as={hasCopied ? CheckIcon : CopyIcon} */
        as={CopyIcon}
        ml="2"
        color={hasCopied ? "primary.500" : "primary.300"}
        className="cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          onCopy();
        }}
      />
    </Tooltip>
  );
};

export const CopyToClipboardButton = ({
  text,
  transform: transform = "normal",
  children,
  ...props
}) => {
  const { onCopy, setValue, hasCopied } = useClipboard("");

  useEffect(() => {
    let _text = text;
    switch (transform) {
      case "uppercase":
        _text = _text.toUpperCase();
        break;
      case "lowercase":
        _text = _text.toLowerCase();
        break;
    }
    setValue(_text);
  }, []);

  return (
    <Button {...props} onClick={onCopy}>
      {hasCopied ? "Copied" : children}
    </Button>
  );
};
